import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { SelectField } from "@/lib/crm";
import { Field, LIC_UNITS, RENEWAL, clean, options } from "@/lib/assets";
import { CompanyPicker } from "@/components/sales/CompanyPicker";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const blank = { name: "", vendor: "", edition: "", quantity: 1, unit: "utente", license_ref: "", start_date: "", end_date: "", renewal: "manuale", notes: "" };

export const LicenseDialog = ({ open, onOpenChange, lic, presetCompany, preset, onSaved }) => {
  const [f, setF] = useState(blank);
  const [company, setCompany] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    setCompany(lic ? { id: lic.company_id, name: lic.company_name } : presetCompany || null);
    setF(lic ? Object.fromEntries(Object.keys(blank).map((k) => [k, lic[k] ?? ""])) : { ...blank, ...preset });
  }, [open, lic, presetCompany, preset]);
  const s = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const v = (k) => (val) => setF((x) => ({ ...x, [k]: val }));
  const save = async () => {
    setBusy(true);
    const body = clean({ ...f, quantity: Number(f.quantity) });
    try {
      if (lic) { await api.patch(`/licenses/${lic.id}`, body); toast.success("Licenza aggiornata"); onSaved?.(lic.id); }
      else { const r = await api.post("/licenses", { ...body, company_id: company.id }); toast.success(`Licenza ${r.data.code} registrata`); onSaved?.(r.data.id); }
      onOpenChange(false);
    } catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}><DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-xl" data-testid="license-dialog">
      <DialogHeader><DialogTitle>{lic ? `Modifica ${lic.code}` : "Nuova licenza"}</DialogTitle>
        <DialogDescription>Diritto d'uso, separato dagli asset. Non inserire mai la chiave di licenza: solo un riferimento.</DialogDescription></DialogHeader>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {!lic && <div className="sm:col-span-2"><CompanyPicker value={company} onChange={setCompany} disabled={!!presetCompany} testId="license-company" /></div>}
        <Field l="Nome" className="sm:col-span-2"><Input value={f.name} onChange={s("name")} maxLength={200} placeholder="Es. Microsoft 365 Business Standard" data-testid="license-name" /></Field>
        <Field l="Vendor"><Input value={f.vendor} onChange={s("vendor")} data-testid="license-vendor" /></Field>
        <Field l="Edizione"><Input value={f.edition} onChange={s("edition")} data-testid="license-edition" /></Field>
        <Field l="Quantità"><Input type="number" min={1} value={f.quantity} onChange={s("quantity")} data-testid="license-quantity" /></Field>
        <SelectField label="Unità" value={f.unit} onChange={v("unit")} options={options(LIC_UNITS)} testId="license-unit" />
        <Field l="Inizio"><Input type="date" value={f.start_date} onChange={s("start_date")} data-testid="license-start" /></Field>
        <Field l="Scadenza"><Input type="date" value={f.end_date} onChange={s("end_date")} data-testid="license-end" /></Field>
        <SelectField label="Rinnovo" value={f.renewal} onChange={v("renewal")} options={options(RENEWAL)} testId="license-renewal" />
        <Field l="Riferimento (no chiavi)"><Input value={f.license_ref} onChange={s("license_ref")} placeholder="Es. ID ordine vendor" data-testid="license-ref" /></Field>
        <Field l="Note" className="sm:col-span-2"><Input value={f.notes} onChange={s("notes")} data-testid="license-notes" /></Field>
      </div>
      <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
        <Button onClick={save} disabled={busy || !f.name.trim() || !company || !(Number(f.quantity) >= 1)} data-testid="license-dialog-save">Salva</Button></DialogFooter>
    </DialogContent></Dialog>
  );
};
